import { useMemo } from 'react';
import {
  Home as HomeIcon,
  Layers as LayersIcon,
  PhotoCamera as PhotoCameraIcon
} from '@mui/icons-material';
import { MarketCode } from '@homesusa/core';
import { KpiType } from '../enums';

interface KpiConfigItem {
  title: string;
  icon: React.ElementType;
  tooltip: string;
  route: string;
  isVisible?: boolean;
}
export const useKpiConfig = (currentMarket: MarketCode) => {
  return useMemo(
    () =>
      ({
        [KpiType.Photo]: {
          title: 'Photo',
          icon: PhotoCameraIcon,
          tooltip: 'photoDetails',
          route: 'photo-details'
        },
        [KpiType.Residential]: {
          title: 'Residential',
          icon: HomeIcon,
          tooltip: 'residentialDetails',
          route: 'sale-requests'
        },
        [KpiType.Lot]: {
          title: 'Lot',
          icon: LayersIcon,
          tooltip: 'lotDetails',
          route: 'lot-requests',
          isVisible: currentMarket === MarketCode.Austin
        }
      }) as Record<KpiType, KpiConfigItem>,
    [currentMarket]
  );
};
